import { useSelector } from "react-redux";
import EditProuductPageComponent from "./components/EditProductPageComponent";
import axios from "axios";
import { URL } from "../../App";

const fetchProduct = async (productId) => {
  const { data } = await axios.get(`${URL}/api/products/get-one/${productId}`);
  return data;
}

const updateProductApiRequest = async (productId, formInputs) => {
  const config = {
    headers: {
      Authorization:
      sessionStorage.getItem("access_token") ||
      localStorage.getItem("access_token"),
    },
  };
  const { data } = await axios.put(`${URL}/api/products/admin/${productId}`, config, {
    ...formInputs
  });
  return data;
}

const AdminEditProuductPage = () => {

  const { categories } = useSelector((state) => state.getCategories);
  console.log(categories)

  return (
    <EditProuductPageComponent 
      categories={categories} 
      fetchProduct={fetchProduct}
      updateProductApiRequest={updateProductApiRequest}
    />
  );
};

export default AdminEditProuductPage;
